import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _SCREEN_METADATA_CONF;
import { useTranslation } from "@i18n";
import { useMemo } from "react";
export var SELL_CAR_SCREENS = {
  CAR_MAKE: "car-make",
  CAR_MODEL: "car-model",
  CAR_EXTENSION: "car-extension",
  CAR_YEAR: "car-year",
  CAR_ODOMETER: "car-odometer",
  CAR_OWNERSHIP: "car-ownership",
  CONTACT_INFO: "user_info",
  ESTIMATED_PRICE: "estimated_price",
  BOOKING_APPOINTMENT: "booking-appointment",
  FEES_PAYMENT: "fees_payment",
  PAYMENT_SUCCESS: "payment_success",
  PAYMENT_FAILED: "payment-failed",
  BOOKING_SUCCESS: "booking_success",
  REJECTED: "rejected",
  CAR_LOCATION_PICKED: "car_location_picked",
  CAR_BOOKING_DATE_TIME: "booking_date_and_time",
  NOT_APPROVED_FOR_INSPECTION: "not_approved_for_inspection",
  CAR_INITIAL: "car_initial"
};
export var SCREENS_HAVE_TAGS = [SELL_CAR_SCREENS.CAR_MAKE, SELL_CAR_SCREENS.CAR_MODEL, SELL_CAR_SCREENS.CAR_YEAR, SELL_CAR_SCREENS.CAR_EXTENSION, SELL_CAR_SCREENS.CAR_ODOMETER, SELL_CAR_SCREENS.CAR_OWNERSHIP, SELL_CAR_SCREENS.CONTACT_INFO];

// Map API step keys to screen routes
export var API_STEP_TO_SCREEN = {
  "user_info": SELL_CAR_SCREENS.CONTACT_INFO,
  "estimated_price": SELL_CAR_SCREENS.ESTIMATED_PRICE,
  "car_location_picked": SELL_CAR_SCREENS.CAR_LOCATION_PICKED,
  "booking_date_and_time": SELL_CAR_SCREENS.CAR_BOOKING_DATE_TIME,
  "fees_payment": SELL_CAR_SCREENS.FEES_PAYMENT,
  "booking_success": SELL_CAR_SCREENS.BOOKING_SUCCESS,
  "rejected": SELL_CAR_SCREENS.REJECTED
};
var SCREEN_METADATA_CONFIG = (_SCREEN_METADATA_CONF = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_SCREEN_METADATA_CONF, SELL_CAR_SCREENS.CAR_INITIAL, {
  titleKey: "",
  icon: "",
  step: 0,
  totalSteps: 0
}), SELL_CAR_SCREENS.CAR_MAKE, {
  titleKey: "sell_trade_v2/car_make_title",
  icon: "material-symbols--directions-car-rounded",
  step: 1,
  totalSteps: 9
}), SELL_CAR_SCREENS.CAR_MODEL, {
  titleKey: "sell_trade_v2/car_model_title",
  icon: "material-symbols--car-tag-outline-rounded",
  step: 2,
  totalSteps: 9
}), SELL_CAR_SCREENS.CAR_EXTENSION, {
  titleKey: "sell_trade_v2/car_trim_title",
  icon: "material-symbols--laptop-car-outline-rounded",
  step: 3,
  totalSteps: 9
}), SELL_CAR_SCREENS.CAR_YEAR, {
  titleKey: "sell_trade_v2/car_year_title",
  icon: "material-symbols--calendar-today-outline-rounded",
  step: 4,
  totalSteps: 9
}), SELL_CAR_SCREENS.CAR_ODOMETER, {
  titleKey: "sell_trade_v2/car_odometer_title",
  icon: "material-symbols--parking-meter-outline-rounded",
  step: 5,
  totalSteps: 9
}), SELL_CAR_SCREENS.CAR_OWNERSHIP, {
  titleKey: "sell_trade_v2/car_ownership_title",
  icon: "material-symbols--id-card-outline-rounded",
  step: 6,
  totalSteps: 9
}), SELL_CAR_SCREENS.CONTACT_INFO, {
  titleKey: "sell_trade_v2/contact_info_title",
  icon: "material-symbols--person-outline-rounded",
  step: 7,
  totalSteps: 9
}), SELL_CAR_SCREENS.ESTIMATED_PRICE, {
  titleKey: "sell_trade_v2/estimated_page_price_title",
  icon: "material-symbols--sell-outline",
  step: 8,
  totalSteps: 12
}), SELL_CAR_SCREENS.CAR_LOCATION_PICKED, {
  titleKey: "sell_trade_v2/car_location_title",
  icon: "material-symbols--location-on-outline-rounded",
  step: 11.5,
  totalSteps: 12
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_SCREEN_METADATA_CONF, SELL_CAR_SCREENS.BOOKING_APPOINTMENT, {
  titleKey: "sell_trade_v2/booking_appointment_title",
  icon: "material-symbols--calendar-month-outline-rounded",
  step: 12,
  totalSteps: 12
}), SELL_CAR_SCREENS.FEES_PAYMENT, {
  titleKey: "sell_trade_v2/fees_payment_title",
  icon: "material-symbols--payments-outline-rounded",
  step: 12,
  totalSteps: 12
}), SELL_CAR_SCREENS.BOOKING_SUCCESS, {
  titleKey: "sell_trade_v2/booking_success_title",
  icon: "material-symbols--check-circle-outline-rounded",
  step: 12,
  totalSteps: 12
}), SELL_CAR_SCREENS.REJECTED, {
  titleKey: "sell_trade_v2/rejected_title",
  icon: "material-symbols--cancel-outline-rounded",
  step: 0,
  totalSteps: 0
}), SELL_CAR_SCREENS.CAR_BOOKING_DATE_TIME, {
  titleKey: "sell_trade_v2/booking_date_and_time_title",
  icon: "material-symbols--edit-calendar",
  step: 12,
  totalSteps: 12
}), SELL_CAR_SCREENS.PAYMENT_SUCCESS, {
  titleKey: "sell_trade_v2/payment_success_title",
  icon: "material-symbols--check-circle-outline-rounded",
  step: 0,
  totalSteps: 0
}), SELL_CAR_SCREENS.PAYMENT_FAILED, {
  titleKey: "sell_trade_v2/payment_failed_title",
  icon: "material-symbols--error-outline-rounded",
  step: 0,
  totalSteps: 0
}), SELL_CAR_SCREENS.NOT_APPROVED_FOR_INSPECTION, {
  titleKey: "",
  icon: "material-symbols--error-outline-rounded",
  step: 0,
  totalSteps: 0
}));
export var useScreenMetadata = function useScreenMetadata() {
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  return useMemo(function () {
    var metadata = {};
    Object.entries(SCREEN_METADATA_CONFIG).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        screen = _ref2[0],
        config = _ref2[1];
      metadata[screen] = {
        title: tShort(config.titleKey, {
          ns: "web_sell_trade"
        }),
        icon: config.icon,
        step: config.step,
        totalSteps: config.totalSteps
      };
    });
    return metadata;
  }, [tShort]);
};